export default {
    method: 'PASSWORD',
    authenticated: false,
    active: false,
    section: null,
    response: {title: null, description: null, class: null }
}
